export default function setupAxios(axios, store,history) {
  axios.interceptors.request.use(
    config => {
      const {
        auth: { authToken }
      } = store.getState();

      if (authToken) {
        config.headers.auth = `Bearer ${authToken}`;
      }

      return config;
    },
    err => Promise.reject(err)
  );
  axios.interceptors.response.use((response) => {
    const {data} = response
    if(!data.success && (data.code === 1015 || data.code === 1009)) {
      if(typeof window !== "undefined") window.location.href = ("/logout");
    }
    return response
  }, () => {
  });
}
